import { useState, useEffect } from 'react';

export default function StickyBottomBar() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show bar after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToChooser = () => {
    const element = document.getElementById('chooser');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 bg-[#0a1628]/98 backdrop-blur-md border-t-2 border-[#DC2626]/30 shadow-2xl transition-transform duration-300 ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-6 py-3 sm:py-4">
        <div className="flex items-center justify-between gap-2 sm:gap-4">
          {/* Left Side - Message */}
          <div className="hidden lg:block">
            <p className="text-white font-bold text-lg">
              Ready to stop being pushed around?
            </p>
            <p className="text-gray-400 text-sm">
              Get legal protection for less than $1/day
            </p>
          </div>

          {/* Right Side - CTA Button */}
          <button
            onClick={scrollToChooser}
            className="w-full md:w-auto bg-[#DC2626] hover:bg-[#B91C1C] text-white font-black text-xs sm:text-sm md:text-base lg:text-lg px-3 sm:px-4 md:px-6 lg:px-8 py-3 sm:py-4 rounded-lg transition-all duration-300 shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer flex items-center justify-center gap-1 sm:gap-2 md:gap-3"
          >
            <i className="ri-shield-fill text-base sm:text-lg md:text-xl lg:text-2xl"></i>
            <span className="hidden sm:inline">ACTIVATE MY SHIELD</span>
            <span className="sm:hidden">GET PROTECTED</span>
            <i className="ri-arrow-right-line text-sm sm:text-base md:text-lg lg:text-xl"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
